var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFridgeG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8406 32.1556H10.0819C8.35774 32.1556 6.95453 30.6942 6.95453 28.8978V3.25843C6.95453 1.46144 8.35774 0 10.0819 0H24.84C26.5653 0 27.968 1.46144 27.968 3.25843V28.8978C27.968 30.6942 26.5653 32.1556 24.8406 32.1556ZM10.0819 2.05728C9.4464 2.05728 8.92962 2.59626 8.92962 3.25787V28.8972C8.92962 29.5594 9.44693 30.0984 10.0819 30.0984H24.84C25.4756 30.0984 25.9923 29.5594 25.9923 28.8978V3.25843C25.9923 2.59626 25.475 2.05784 24.84 2.05784L10.0819 2.05728Z",
    fill: "#44C056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0087 9.86106H10.9144C10.3687 9.86106 9.92682 9.40067 9.92682 8.83214C9.92682 8.26362 10.3692 7.80322 10.9144 7.80322H24.0087C24.5544 7.80322 24.9968 8.26362 24.9968 8.83214C24.9968 9.40067 24.5538 9.86106 24.0087 9.86106Z",
    fill: "#44C056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0087 14.8564H10.9144C10.3687 14.8564 9.92682 14.396 9.92682 13.8275C9.92682 13.259 10.3692 12.7986 10.9144 12.7986H24.0087C24.5544 12.7986 24.9968 13.259 24.9968 13.8275C24.9968 14.396 24.5538 14.8564 24.0087 14.8564Z",
    fill: "#44C056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0087 19.8728H10.9144C10.3687 19.8728 9.92682 19.4124 9.92682 18.8439C9.92682 18.2753 10.3692 17.8149 10.9144 17.8149H24.0087C24.5544 17.8149 24.9968 18.2753 24.9968 18.8439C24.9968 19.4124 24.5538 19.8728 24.0087 19.8728Z",
    fill: "#44C056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0087 24.8891H10.9144C10.3687 24.8891 9.92682 24.4287 9.92682 23.8602C9.92682 23.2917 10.3692 22.8313 10.9144 22.8313H24.0087C24.5544 22.8313 24.9968 23.2917 24.9968 23.8602C24.9968 24.4287 24.5538 24.8891 24.0087 24.8891Z",
    fill: "#44C056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 34H9.30476C9.18854 34 9.09442 33.5012 9.09442 32.8853C9.09442 32.2693 9.18865 31.7705 9.30476 31.7705H12.0938C12.21 31.7705 12.3042 32.2693 12.3042 32.8853C12.3042 33.5012 12.2099 34 12.0938 34Z",
    fill: "#44C056"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9329 34H22.1439C22.0277 34 21.9336 33.5012 21.9336 32.8853C21.9336 32.2693 22.0278 31.7705 22.1439 31.7705H24.9329C25.0492 31.7705 25.1434 32.2693 25.1434 32.8853C25.1434 33.5012 25.049 34 24.9329 34Z",
    fill: "#44C056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridgeG);
export default __webpack_public_path__ + "static/media/fridgeG.6d3d415cb4afa863e1f083015f89b43f.svg";
export { ForwardRef as ReactComponent };